/* GoRetrofits "Stock to shock" carousel — a sliding track of before/after
   comparison sliders, paged with the ‹ progress-bar › control. */
(function () {
  if (customElements.get('sts-carousel')) return;

  class StsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.sts-carousel__track');
      this.slides = Array.prototype.slice.call(
        this.querySelectorAll('.sts-carousel__track > .comparison-slider')
      );
      this.fill = this.querySelector('.sts-carousel__progress > span');
      this.prevBtn = this.querySelector('.sts-nav--prev');
      this.nextBtn = this.querySelector('.sts-nav--next');
      this.count = this.slides.length;
      this.current = 0;
      this.userEngaged = false;
      if (!this.track || this.count === 0) return;

      if (this.prevBtn)
        this.prevBtn.addEventListener('click', () => {
          this.userEngaged = true;
          this.go(-1);
        });
      if (this.nextBtn)
        this.nextBtn.addEventListener('click', () => {
          this.userEngaged = true;
          this.go(1);
        });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') { event.preventDefault(); this.userEngaged = true; this.go(1); }
        else if (event.key === 'ArrowLeft') { event.preventDefault(); this.userEngaged = true; this.go(-1); }
      });

      /* Any hands-on interaction (incl. dragging a before/after handle) cancels
         the one-time auto-advance cue. */
      this.addEventListener(
        'pointerdown',
        () => {
          this.userEngaged = true;
        },
        { passive: true }
      );

      this.render();
      this.initHintOnce();
    }

    /* One-time cue: ~2s after the carousel first scrolls into view, page to the
       next comparison so the reader notices it can be advanced. Fires once ever
       (remembered in the browser), and never if the reader already took over. */
    initHintOnce() {
      if (this.count < 2) return;
      var KEY = 'gr-difference-hint-seen';
      try {
        if (localStorage.getItem(KEY)) return;
      } catch (e) {
        /* storage blocked */
      }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var self = this;
      var scroller = document.querySelector('.page-wrapper');
      var timer = null;
      var done = false;

      function inView() {
        var r = self.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        return r.top < vh * 0.75 && r.bottom > vh * 0.3;
      }

      function cleanup() {
        if (timer) clearTimeout(timer);
        timer = null;
        if (scroller) scroller.removeEventListener('scroll', check);
        window.removeEventListener('scroll', check);
        window.removeEventListener('resize', check);
      }

      function fire() {
        timer = null;
        if (done) return;
        done = true;
        try {
          localStorage.setItem(KEY, '1');
        } catch (e) {
          /* ignore */
        }
        cleanup();
        if (!self.userEngaged && self.current === 0) self.go(1);
      }

      function check() {
        if (done) return;
        if (self.userEngaged) {
          done = true;
          cleanup();
          return;
        }
        if (inView()) {
          if (!timer) timer = setTimeout(fire, 2000);
        } else if (timer) {
          clearTimeout(timer);
          timer = null;
        }
      }

      if (scroller) scroller.addEventListener('scroll', check, { passive: true });
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check, { passive: true });
      check();
      requestAnimationFrame(check);
      setTimeout(check, 600);
    }

    go(dir) {
      this.setIndex(this.current + dir);
    }

    setIndex(i) {
      this.current = Math.max(0, Math.min(this.count - 1, i));
      this.render();
    }

    render() {
      this.track.style.transform = 'translateX(-' + this.current * 100 + '%)';

      if (this.fill) {
        const pct = this.count > 1 ? (this.current / (this.count - 1)) * 100 : 100;
        // scaleX instead of width: composited, no relayout per frame
        this.fill.style.transform = 'scaleX(' + Math.max(12, pct) / 100 + ')';
      }
      if (this.prevBtn) this.prevBtn.disabled = this.current === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.current === this.count - 1;
    }
  }

  customElements.define('sts-carousel', StsCarousel);
})();
